###
# Отображение заказов в маркеры
###
computedMarkers = (dependentKey) ->

  options =
    # При добавлении заказа
    addedItem: (array, order, changeMeta, instanceMeta) ->
      if order.get('takeaway')
        lat = order.get('restaurant.latitude')
        lon = order.get('restaurant.longitude')
      else
        lat = order.get('latitude')
        lon = order.get('longitude')

      marker = null

      if lat and lon and window.mapgl
        coordinates = [lon, lat]

        marker = new mapgl.Marker @get('map'),
          coordinates:  coordinates
          icon:         order.get('marker')
          size:         [16,16]
          map:          @get('map')
          # label:        {text: order.get('number'), minZoom: 12}

        @registerMarker(marker)

        marker.on 'click', (e) =>
          @sendAction('onOrderSelected', order)

      array.insertAt changeMeta.index, { marker: marker, model: order }
      array

    # При удалении заказа
    removedItem: (array, item, changeMeta, instanceMeta) ->
      arrayItem = array.findBy('model', item)
      return unless arrayItem

      marker = arrayItem.marker
      marker.destroy()

      array.removeAt(changeMeta.index, 1)
      array

  Em.arrayComputed(dependentKey, options)


###
# Маркеры для курьеров
###
renderCouriers = ->

  showCourierPopup = (courier, currentOrder, marker, e) =>
    ctx = @
    courier.getStatus()
    .then =>


      popup = new mapgl.HtmlMarker @map,
        coordinates: marker.getCoordinates(), html: getInfoWindowContent(courier, currentOrder),

      @infowindows.push popup

      @map.setPadding {right: 600}
      @map.setCenter popup.getCoordinates()
      content = popup.getContent()
      content
        .querySelector('.close')
        .addEventListener 'click', () => popup.destroy()

      isBefore = (el1, el2) ->
        if el1.parentNode == el2.parentNode
          cur = el1.previousSibling
          while cur
            return true if cur == el2
            cur = cur.previousSibling
        false

      el = null
      items = content.querySelectorAll('li')
      list = content.querySelector('ul')
      idsArr = Array.from((list?.querySelectorAll('li') or [])).map (el) => Number el.dataset.orderId

      if list and items
        list.addEventListener 'dragover', (e) ->
          e.preventDefault()

        items.forEach (item) ->
          item.setAttribute 'draggable', true

          item.addEventListener 'dragstart', (e) ->
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData 'text/plain', null
            el = e.target

          item.addEventListener 'dragend', (e) ->
            el.classList.remove 'hidden'
            el = null
            updateIdsArr(ctx)

          item.addEventListener 'dragover', (e) ->
            e.preventDefault()
            el.classList.add 'hidden'
            if el != e.target && el.parentNode == e.target.parentNode
              if isBefore el, e.target
                e.target.parentNode.insertBefore el, e.target
              else
                e.target.parentNode.insertBefore el, e.target.nextSibling

          item.addEventListener 'dragenter', (e) ->
            e.preventDefault()

      updateIdsArr = (ctx) ->
        newIdsArr = Array.from(list.querySelectorAll('li')).map (el) => Number el.dataset.orderId
        if !_.isEqual(newIdsArr, idsArr)
          idsArr = newIdsArr
          previousIdsArr = newIdsArr
          courier.nonRESTAction('POST', 'update_priorities', {order_ids: idsArr}).then (data)=>
            ctx.get('notifier').pushNotification
              type: 'success'
              message: data.message
              duration: 3000

      if currentOrder && false
        currentOrder.get('restaurant')
        .then (restaurant) =>
          restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
          address_marker = @get('markers').findBy('model', currentOrder)?.marker

          from_point = marker.getCoordinates()
          if courier.get('status') == 'delivering'
            to_point = address_marker?.getCoordinates()
          else
            to_point = restaurantMarker.getCoordinates()

          @drawLine(from_point, to_point)

  findOrCreateMarker = (courier) =>
    if !@get('courierMarkerCache')
      @set('courierMarkerCache', Em.A([]))

    match = @get('courierMarkerCache').filter (m) =>
      m.id is courier.get('id')

    if match and match.length >= 1
      return match[0]

    return unless window.mapgl

    coordinates = [courier.get('lon'), courier.get('lat')]

    marker = new mapgl.HtmlMarker @get('map'),
      coordinates:  coordinates
      html: "<div class='courier-avatar #{courier.get('status')}' id='avatar-#{courier.get('id')}'>
              <div class='avatar-container'>
                  <img src='#{courier.get('avatarUrl')}'/>
              </div>
            </div>"
      # label:        {text: courier.get('name'), minZoom: 15, fontSize: 12, haloRadius: 1, haloColor: '#ffffff'}


    id = courier.get('id')
    markerObj = Em.Object.create({ id, marker })
    @get('courierMarkerCache').pushObject(markerObj)
    Em.run.next =>
      $("#avatar-#{courier.get('id')}").on 'click', (e) =>
        @infowindows = [] unless @infowindows
        while iw = @infowindows.shift()
          iw.destroy()

        courier.get('currentOrder')
        .then (currentOrder) =>
          showCourierPopup(courier, currentOrder, marker, e)

    markerObj

  formatDate = (date, tz) =>
    d = moment(new Date date)
    d = d.tz(tz) if tz
    if d.isSame(moment(), 'day')
      d.format('H:mm')
    else
      d.format('DD MMMM в H:mm')



  getInfoWindowContent = (courier, currentOrder) =>

    params = {}

    if currentOrder
      params = {
        restaurant: currentOrder.get('restaurant.name'),
        address: currentOrder.get('address_text')
      }

    ret = "<div class='courier-info-window'><span class=close></span>
        <h4>#{courier.get('name')}</h4>
        <p>#{Em.I18n.t 'orders_map.courier_popup.statuses.' + courier.get('status'), params}</p>"

    if currentOrder
      ret += "<a class='order-number' href='#/orders/map/#{currentOrder.get('id')}?f=current'>
        #{Em.I18n.t 'order.map_popup.order_name', order: currentOrder.get('number')}
      </a>"


    orders = courier.get('statusData').orders

    if orders.length > 0
      ret += '<h5>Очередь заказов</h5>'
      ret += '<ul>'
      # ret += '<tr><th>cтатус</th><th>забрать</th><th>доставить</th><th>Заказ и адрес</th></tr>'
      orders.forEach (order) =>

        pickup = formatDate(order.picked_up_at || order.pick_up_at, currentOrder?.get('timezone'))
        delivery_at = formatDate(order.delivery_at, currentOrder?.get('timezone'))

        ret += "<li data-order-id='#{order.id}'>
        <img class='drag-indicator' src='images/drag-indicator.svg'/>
          <div>
            #{Em.I18n.t 'order.status.'+order.status}<br>
            <a class='order-number' href='#/orders/map/#{order.id}?f=current'>
              №#{order.number}
            </a>
          </div>
          <div>#{pickup}<br>#{order.restaurant_name}</div>
          <div>&rarr;</div>
          <div>#{delivery_at}<br>#{order.address}</div>
        </li>"

      ret += '</ul>'

    ret += "</div>"

  i = 0
  @get('courierPositions').forEach (c) =>
  
    hideUnathorizedCouriers = localStorage.getItem('hideUnauthorizedCouriers') == 'true'
    renderCourierMarker = if hideUnathorizedCouriers then c.get('lat') && c.get('lng') && c.get('status') != 'offline' && c.get('is_running') else c.get('lat') && c.get('lng')
    m = findOrCreateMarker( c )
    marker = m.get('marker')
    
    if renderCourierMarker
      @registerMarker(marker)
    else
      @removeMarker(c, marker, @get('courierMarkerCache'))



    pos    = [c.get('lng'), c.get('lat')]
    oldPos = marker.getCoordinates()

    if oldPos[0] != pos[0] || oldPos[1] != pos[1]
      marker.setCoordinates( pos )
    # marker.setIcon 
    #   icon:  c.get('avatarUrl')
    #   size:  [40,40]



###
# Компонент карты
###
App.OrdersMapTwoGisComponent = Em.Component.extend
  classNames: ['orders-map', 'orders-map-two-gis']

  map:           null
  orders:        null
  restaurants:   null
  selectedOrder: null
  markers:        computedMarkers('orders', 'map')
  session:  Em.inject.service()
  notifier: Em.inject.service('notifier')

  animateNewMarkers: false

  redrawCouriers: renderCouriers.observes('courierPositions')
  courierMarkerCache: null

  ###
  # Инициализация карты
  ###
  registerMap: (->
    return unless @$()?.get(0)

    # очень кривое решение ожидания загрузки, но должно работать
    unless window.mapgl
      setTimeout =>
        @registerMap()
      , 1000

      return

    @popup = Em.$('<div id="courier-info-window-container"><div class=close></div><div class=contents></div></div>').appendTo('body')

    mapOptions = {
      zoom: 3
      center: [71.5048241, 56.0031895]

      scrollwheel: localStorage.getItem('mapScrollOnMouseWheel') == 'true'
      disableDefaultUI: true
      zoomControl: 'bottomLeft'
      key: @get('session.twoGis_token')
      style: 'c080bb6a-8134-4993-93a1-5b4d8c36a59b'
    }

    map = new mapgl.Map(@$().get(0), mapOptions)

    @set('map', map)

    @set('initialized', true)
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)

    @addRestaurantsMarkers()
    @fitBounds()

    @set('animateNewMarkers', true)

    @sendAction('onMapRegistered', map)

  ).on('didInsertElement')

  removeMarker: (c, marker, cache) ->
    return unless c or marker
    marker.destroy()
    cachedMarkers = cache || []
    index = cachedMarkers.findIndex (m) =>
      m.id is c.get('id')
    cachedMarkers.splice(index, 1) if index > -1

  # глобальная структура для регистрации всех маркеров, добавленных на карту
  # чтобы удалять их перед записью карты в кеш при выходе
  registerMarker: (marker) ->
    window.cachedMarkers = [] unless window.cachedMarkers
    window.cachedMarkers.push marker

  registerLine: (line) ->
    window.cachedLines = [] unless window.cachedLines
    window.cachedLines.push line

  clearLines: () ->
    return false unless window.cachedLines
    window.cachedLines.forEach (line) ->
      line.destroy() if line
    window.cachedLines = []

  extendBounds: (position, bounds=null) ->
    if bounds == null
      bounds = {}

    if Em.$.isEmptyObject bounds
      bounds.northEast = position.map((x) => x)
      bounds.southWest = position.map((x) => x)
    else
      bounds.southWest[0] = position[0] if bounds.southWest[0] > position[0]
      bounds.southWest[1] = position[1] if bounds.southWest[1] > position[1]

      bounds.northEast[0] = position[0] if bounds.northEast[0] < position[0]
      bounds.northEast[1] = position[1] if bounds.northEast[1] < position[1]
    bounds

  ###
  # Центрирование карты
  ###
  fitBounds: ->
    # return

    map = @get('map')
    bounds = {}

    has_points = false
    @get('markers').filter (marker) => marker.marker
    .map (marker) =>
      @extendBounds(marker.marker.getCoordinates(), bounds)
      has_points = true

    @get('restaurants').forEach (restaurant) =>
      if restaurant.get('hasCoordinates')
        coordinates = [restaurant.get('longitude'), restaurant.get('latitude')]
        @extendBounds(coordinates, bounds)
        has_points = true

    map.fitBounds(bounds, padding: {bottom: 100, left: 50, right: 50, top: 100}) if has_points

  initialized: false

  initializeProps: (->
    @set('obtainDefers', Em.A([]))
  ).on('init')

  # ---
  # Запрашивает экземпляр карты. Гарантирует, что карта инициализирована
  # ---
  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get('initialized')
      defer.resolve(@get('map'))
    else
      @get('obtainDefers').pushObject(defer)

    defer.promise

  drawLine: (from, to) ->
    @clearLines()
    map = @get('map')

    return unless from and to

    if from && from[0] == to[0] && from[1] == to[1]
      map.fitBounds( @extendBounds(from) )
      map.setZoom(17)
      return

    bounds = {}
    @extendBounds(from, bounds)
    @extendBounds(to, bounds)
    map.setPadding {bottom: 0, left: 0, right: 0, top: 0}
    map.fitBounds bounds, padding: {bottom: 100, left: 50, right: 370, top: 100}

    polyline = new mapgl.Polyline map,
      coordinates:  [from, to]
      width:        3
      color:        '#00b7ff'
      dashLength:   3
      gapLength:    8
      gapColor:     '#ffffff39'
      userData: @get('selectedOrder').get('id')

    @registerLine(polyline)

  ###
  # Центрирование по маркеру
  ###
  onSelectedOrderChanged: (->
    @obtainMap()
    .then (map) =>

      return unless @get('selectedOrder')?

      order = @get('selectedOrder')

      order.reload()
      .then =>
        order.get('restaurant')
        .then (restaurant) =>
          return unless restaurant

          restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
          marker = @get('markers').findBy('model', order)?.marker

          return unless marker

          unless restaurantMarker
            @get('map').setZoom(17)
            @get('map').panTo( marker.getCoordinates() )
            return

          orderPosition      = marker.getCoordinates()
          restaurantPosition = restaurantMarker.getCoordinates()

          @drawLine(orderPosition, restaurantPosition)

  ).observes('selectedOrder').on('didInsertElement')

  onOrderStatusChanged: (->
    @obtainMap()
    orders = @get('orders')
    orders.forEach (order) =>
      marker = @get('markers').findBy('model', order)?.marker
      cachedLine = if window.cachedLines then window.cachedLines.find (line) => line.userData == order.get('id') else null
      if marker
        if order.get('status') == 'complete' 
          marker.destroy()
          cachedLine?.destroy()
        else
          marker.destroy()

          lat = null
          lon = null

          if order.get('takeaway')
            lat = order.get('restaurant.latitude')
            lon = order.get('restaurant.longitude')
          else
            lat = order.get('latitude')
            lon = order.get('longitude')
          
          coordinates = [lon, lat]
          marker = new mapgl.Marker @get('map'),
            coordinates:  coordinates
            icon:         order.get('marker')
            size:         [16,16]
            map:          @get('map')
        
  ).observes('orders.@each.status')

  ###
  # Добавить рестораны на карту
  ###
  addRestaurantsMarkers: ->

    map       = @get('map')
    icon = "images/map-markers/restaurant-marker-round.png"

    @set('restaurantsMarkers', Ember.Object.create())

    @get('restaurants')
    .filter (r) => r.get('hasCoordinates')
    .forEach (restaurant) =>
      lat = restaurant.get('latitude')
      lon = restaurant.get('longitude')

      coordinates = [lon, lat]

      marker = new mapgl.Marker map,
        coordinates:  coordinates
        icon:         icon,
        size:         [28,28]
        # label:        {text: restaurant.get('name'), minZoom: 15, fontSize: 12, haloRadius: 1, haloColor: '#ffffff'}

      @get('restaurantsMarkers').set(restaurant.get('id'), marker)
